import { useEffect, useState } from "react";
import { X, ZoomIn } from "lucide-react";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    alt: "Modern dental office with chair and equipment",
    span: "sm:col-span-2 sm:row-span-2",
  },
  {
    src: "https://images.pexels.com/photos/5355921/pexels-photo-5355921.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Clean and sterile dental clinic with modern equipment",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/9062527/pexels-photo-9062527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Bright and sterile dental clinic room",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=1200&q=80",
    alt: "Dental treatment tools and instruments",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=1200&q=80",
    alt: "Happy patient smiling at Abhayam Dental Clinic",
    span: "sm:col-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=1200&q=80",
    alt: "Dental clinic reception area",
    span: "",
  },
];

export const Gallery = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = active !== null ? "hidden" : "";
  }, [active]);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-20 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12 reveal">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#009688]/10 text-[#009688] text-xs font-semibold tracking-wide uppercase">
              Our Clinic
            </div>
            <h2 className="mt-5 text-4xl sm:text-5xl font-semibold tracking-tight text-[#1F2937] leading-[1.05]">
              A modern space designed{" "}
              <span className="text-[#009688]">for comfort</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 auto-rows-[180px] sm:auto-rows-[200px] gap-3 sm:gap-4">
          {IMAGES.map((img, i) => (
            <button
              key={i}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(i)}
              className={`group relative rounded-2xl overflow-hidden ${img.span} reveal`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute inset-0 grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-white/95 grid place-items-center">
                  <ZoomIn className="w-5 h-5 text-[#009688]" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm grid place-items-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            data-testid="gallery-lightbox-close"
            onClick={() => setActive(null)}
            aria-label="Close"
            className="absolute top-6 right-6 w-11 h-11 rounded-full bg-white text-[#1F2937] grid place-items-center hover:scale-110 transition-transform"
          >
            <X className="w-5 h-5" />
          </button>
          <img
            src={IMAGES[active].src}
            alt={IMAGES[active].alt}
            className="max-w-full max-h-[85vh] object-contain rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};
